export enum IndexedDbErrorCodes {
    VersionMismatch = 0,
    OpenBlocked = 11
}
